module.exports = __webpack_public_path__ + "img/solution-pv-system-pic.692df80d.jpg";